
<div
	*ngIf="sessionChangedInAnotherTab"
	class="session-change-notice"
	role="alert"
>
	<div>
		<strong>La sesión cambió en otra pestaña</strong>
		<span>Recarga esta página para continuar con la cuenta actualizada.</span>
	</div>
	<button type="button" (click)="reloadForSessionChange()">
		RECARGAR
	</button>
</div>

<router-outlet *ngIf="!isIframe"></router-outlet>
<!-- <div class="loading-icon" *ngIf="loading">
  Cargando...
</div> -->
